import { Component, OnInit } from '@angular/core';
import { Register } from '../../shared/user.model';
import { NgForm } from '@angular/forms';
import { UserService } from '../../shared/user.service';
import { Router } from '@angular/router';
import { ErrorHandler } from '../../shared/ErrorHandler';
import swal from 'sweetalert2';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit {
  register: Register;
  formSubmitted: boolean;
  data: any;
  districtlist: any;
  title = "User Registration";

  constructor(private userService: UserService, private errorHandler: ErrorHandler, private router: Router) {
    this.formSubmitted = false;
    this.register = new Register();
  }

  ngOnInit() {
    this.GetAllDistrict();
  }

  GetAllDistrict() {
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.getAllDistrictName();
    this.data.subscribe(
      (response:any) => {
        this.districtlist = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
     
  }

  onSubmit(form: NgForm) {
    debugger;
    alert("register");
    if (!form.invalid) {
      document.getElementById('loader-spinner').style.display = "block";
      console.log(form.value);
      this.data = this.userService.registerCustomer(form.value);
      this.data.subscribe(
        (response) => {
          document.getElementById('loader-spinner').style.display = "none";
          swal('', 'Registered Successfully!', 'success');
          this.router.navigate(['/login']);
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
    } else
      this.formSubmitted = true;
  }



}



// WEBPACK FOOTER //
// ./src/app/registration/signup/signup.component.ts